import HashLoader from "react-spinners/HashLoader";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#35366f",
};

const Loading = () => {
  return (
    <div className="sweet-loading m-auto">
      <HashLoader
        color={"#6366f1"}
        loading={true}
        cssOverride={override}
        size={80}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
};

export default Loading;
